export const POS_ORDER_CREATING = "POS_ORDER_CREATING";
export const POS_ORDER_CREATED = "POS_ORDER_CREATED";
export const POS_ORDER_ERROR = "POS_ORDER_ERROR";
export const POS_ORDERS_LIST = "POS_ORDERS_LIST";
export const POS_ORDER_CLEAR_LAST = "POS_ORDER_CLEAR_LAST";
